// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGSendOutline = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M12.377 1.772c.68-.183 1.389.005 1.892.508.503.503.69 1.206.508 1.892l-2.468 9.211c-.183.686-.697 1.2-1.383 1.383-.171.046-.343.068-.514.068h-.006c-.509 0-1-.2-1.372-.571l-2.56-2.56c-.668-.668-.668-1.754 0-2.423l3.229-3.228c.223-.223.583-.223.806 0 .222.223.222.582 0 .805L7.28 10.086c-.108.108-.165.251-.165.406 0 .154.057.297.165.405l2.56 2.56c.206.206.503.286.783.212.286-.074.497-.292.577-.578L13.67 3.88c.074-.286 0-.577-.212-.782-.211-.206-.503-.286-.783-.212L3.463 5.354c-.286.075-.497.292-.577.572-.074.285 0 .577.211.783l1.835 1.834c.223.223.222.583 0 .806-.223.223-.583.223-.806 0L2.292 7.514c-.503-.502-.692-1.205-.509-1.89.183-.68.697-1.2 1.383-1.383l9.211-2.47z"
  })
}));
SVGSendOutline.displayName = 'SVGSendOutline';
export default SVGSendOutline;